import { FC } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { sharedProps } from "~/constants";
import { Content, Hero, Meta } from "./components";

const FaqsPage: FC = () => {
  return (
    <>
      <Meta />
      <Flex align="center" direction="column" {...sharedProps.fullBleed}>
        <Hero />
        <Flex
          align="center"
          direction="column"
          maxW="inherit"
          position="relative"
          textAlign="center"
          w="100%"
        >
          <Box
            bg="bg-main"
            h="100%"
            left="inherit"
            objectFit="cover"
            position="absolute"
            top={0}
            w="100%"
            zIndex="-1"
          />
          <Flex
            align="center"
            direction="column"
            mt={6}
            {...sharedProps.max.content}
          >
            <Content />
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default FaqsPage;
